import currencyApp from "./currency-app";
import xeCom from "./xe-com";
import rateAlerts from "./rate-alerts";
import moneyTransfer from "./money-transfer";
import accessibility from "./accessibility";
import designSystem from "./design-system";
import designCollaboration from "./design-collaboration";

const xeCaseStudies = [
  currencyApp,
  xeCom,
  rateAlerts,
  moneyTransfer,
  accessibility,
  designSystem,
  designCollaboration,
];

export default xeCaseStudies;
